<template>
  <el-select
    v-model="dataValue"
    style="width: 200px;"
    placeholder="请选择服务机构">
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.servOrgName"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'ServiceOrgSelect',
  props: ['value', 'callback'],
  data() {
    return {
      list: []
    }
  },
  computed: {
    dataValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    onChage() {
      this.$nextTick(() => {
        const row = this.list.find(i => i.serviceId === this.dataValue)
        row && this.callback && this.callback(row)
      })
    },
    getList() {
      this.$$OrgService.getservorgs({ pageNum: 1, pageSize: 100 })
        .then(res => {
          const { result, message, records } = res.data
          if ([0, 13].includes(result)) {
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" type="text/stylus" scoped></style>
